import React from 'react';

import { useTeams } from '~/hooks/use-teams';

import { useChat } from '../research/use-chat/useChat';
import { BotResponseCard } from './BotResponseCard';
import { ChatMessage } from './ChatMessage';
import { ComposeBar } from './ComposeBar';
import * as S from './LandingPage.styles';
import { LandingPageHeader, Tab } from './LandingPageHeader';

export const LandingPage: React.FC = () => {
  const { postQuestion, conversations } = useChat();
  const { openTaskModule } = useTeams();

  const tabs: Tab[] = [
    { id: 'home', label: 'Home', isActive: false },
    { id: 'chat', label: 'Chat', isActive: true },
    { id: 'directory', label: 'Open Directory', isActive: false },
    { id: 'profile', label: 'Directory Profile', isActive: false },
  ];

  // Placeholder click handlers
  const handleTabClick = (tabId: string) => {
    // eslint-disable-next-line no-console
    console.log('Tab clicked:', tabId);
  };

  const handleMoreClick = () => {
    // eslint-disable-next-line no-console
    console.log('More button clicked');
  };

  const handleSendMessage = (message: string) => {
    postQuestion(message);
  };

  const handleViewReport = (conversationId: string) => {
    const link = `https://test.864453.co.uk/app/alfred?conversationId=${conversationId}&mode=research`;

    // Open in Teams task module if in Teams, otherwise open in new window
    openTaskModule(link, 'Research Report', { width: 1000, height: 800 });
  };

  const handleAttach = () => {
    // eslint-disable-next-line no-console
    console.log('Attach clicked');
  };

  const handleEmoji = () => {
    // eslint-disable-next-line no-console
    console.log('Emoji clicked');
  };

  const handleGif = () => {
    // eslint-disable-next-line no-console
    console.log('GIF clicked');
  };

  const handleSticker = () => {
    // eslint-disable-next-line no-console
    console.log('Sticker clicked');
  };

  const handleSchedule = () => {
    // eslint-disable-next-line no-console
    console.log('Schedule clicked');
  };

  const handleFormat = () => {
    // eslint-disable-next-line no-console
    console.log('Format clicked');
  };

  return (
    <S.Container>
      <LandingPageHeader
        tabs={tabs}
        onTabClick={handleTabClick}
        onMoreClick={handleMoreClick}
      />
      <S.Content>
    {conversations.map((conversation) => {
      const lastState = conversation.tasks?.[0]?.states?.at(-1)
      return(
    <Message key={conversation.id} date={conversation.created_date} handleViewReport={() =>handleViewReport(conversation.id)} loading={conversation.status !== 'Done'} question={conversation.name} answer={lastState?.name === "Answer" ? lastState?.content : undefined} />
   )})}
      </S.Content>
      <ComposeBar
        onSend={handleSendMessage}
        onAttach={handleAttach}
        onEmoji={handleEmoji}
        onGif={handleGif}
        onSticker={handleSticker}
        onSchedule={handleSchedule}
        onFormat={handleFormat}
      />
    </S.Container>
  );
};


const Message = ({handleViewReport, loading, question, date, answer}: {handleViewReport: () => void, loading: boolean, question: string, date: string, answer?: string}) => (     <S.MessagesContainer>
  <S.MessageWrapper>
    <ChatMessage message={question} />
  </S.MessageWrapper>

  
   
 <S.MessageWrapper>
    <S.MetadataRow>
      <S.MetadataLabel>LSEG Workspace (Internal)</S.MetadataLabel>
      <S.MetadataValue>{new Date(date).toLocaleString()}</S.MetadataValue>
    </S.MetadataRow>
    { (loading && !answer) ?  <BotResponseCard
      content={"Loading..."}
    /> :
    <BotResponseCard
      content={answer?.substring(0, 250) as string}
      actionButton={{
        label: 'View Full Report',
        onClick: handleViewReport,
      }}
    />}
  </S.MessageWrapper>
</S.MessagesContainer>
)